import {SET_ERRORS} from "../storeconstants";

export default {
    [SET_ERRORS](state, error) {
        state.token = null;
        state.errors = error;
    },
}